import { CustomerData } from "../../interfaces/CustomerData/CustomerData";
import ProductProperties from "../../interfaces/ProductProperties/ProductProperties";
import SessionStorageProviderProps, { SessionStorageItems } from "./SessionStorageProvider.props";

export default class SessionStorageProvider {
    private props: SessionStorageProviderProps;
    private warenkorbData: Array<ProductProperties>;
    private warenkorbDataCampaign: Array<ProductProperties>;
    private customerData: CustomerData;

    constructor(props: SessionStorageProviderProps) {
        this.props = props;
        this.warenkorbData = [];
        this.warenkorbDataCampaign = [];
        this.customerData = {};
        this.updateSessionStorageProvider();
    }
    
    updateSessionStorageProvider() {
        const warenkorbData = sessionStorage.getItem(SessionStorageItems.CART) || "[]";
        // TODO: Base64 Decoding
        // if(environment.isProductionBuild()) {
        //     const buff = Buffer.from(lsData, 'base64');
        //     lsData = buff.toString('utf8');
        // }
        this.warenkorbData = JSON.parse(warenkorbData) as ProductProperties[];
        
        const customerData = sessionStorage.getItem(SessionStorageItems.CUSTOMER) || '{}';
        this.customerData = JSON.parse(customerData) as CustomerData;
    }
    
    private writeToSessionStorage(item: SessionStorageItems, data: unknown) {
        const dataString = JSON.stringify(data);
        // TODO: Base64 Encoding
        // if(environment.isProductionBuild()) {
        //     const data = productInformationString;
        //     const buff = Buffer.from(data, 'base64');
        //     sessionStorage.setItem("warenkorb", buff as unknown as string);
        // } else {
        sessionStorage.setItem(item, dataString);
        // }
    }

    getProductInformationFromSessionStorage(magicNumber?: string): { productProperties?: ProductProperties, warenkorbData: ProductProperties[] } | undefined {
        return {
            productProperties: magicNumber ? this.warenkorbData.find((productProperties) => productProperties.magicNumber === magicNumber) : undefined,
            warenkorbData: this.warenkorbData
        }
    }

    setProductInformationInSessionStorage(productProperties: ProductProperties[]) {
        this.writeToSessionStorage(SessionStorageItems.CART, productProperties);
        this.updateSessionStorageProvider();
    }



    getCustomerDataFromSessionStorage(): CustomerData {
        return this.customerData;
    }

    setCustomerDataInSessionStorage(customerData: CustomerData) {
        this.writeToSessionStorage(SessionStorageItems.CUSTOMER, customerData);
        this.updateSessionStorageProvider();
    }


    
    updateSessionStorageProviderCampaign(campaignId: string, pageType: string) {
        const warenkorbData = sessionStorage.getItem(`${pageType}_${campaignId}_${SessionStorageItems.CART}`) || "[]";
        // TODO: Base64 Decoding
        // if(environment.isProductionBuild()) {
        //     const buff = Buffer.from(lsData, 'base64');
        //     lsData = buff.toString('utf8');
        // }
        this.warenkorbDataCampaign = JSON.parse(warenkorbData) as ProductProperties[];
        
        const customerData = sessionStorage.getItem(SessionStorageItems.CUSTOMER) || '{}';
        this.customerData = JSON.parse(customerData) as CustomerData;
    }
    
    private writeToSessionStorageCampaign(item: string, data: unknown) {
        const dataString = JSON.stringify(data);
        sessionStorage.setItem(item, dataString);
    }

    getProductInformationFromSessionStorageCampaign(magicNumber?: string): { productProperties?: ProductProperties, warenkorbData: ProductProperties[] } | undefined {
        // console.log('warenkorbCampaign: ', this.warenkorbDataCampaign)
        return {
            productProperties: magicNumber ? this.warenkorbDataCampaign.find((productProperties) => productProperties.magicNumber === magicNumber) : undefined,
            warenkorbData: this.warenkorbDataCampaign
        }
    }

    setProductInformationInSessionStorageForCampaign(productProperties: ProductProperties[], campaignId: string, pageType: string) {
        this.writeToSessionStorageCampaign(`${pageType}_${campaignId}_${SessionStorageItems.CART}`, productProperties);
        this.updateSessionStorageProviderCampaign(campaignId, pageType);
    }

    setCounterForSteps(campaignId: string, pageType: string, step: string) {
        this.writeToSessionStorageCampaign(`${pageType}_${campaignId}_${step}`, step);
    }

    getCounterForSteps(campaignId: string, pageType: string, step: string) {
        return sessionStorage.getItem(`${pageType}_${campaignId}_${step}`);
    }
}